// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React, { useEffect, useRef } from 'react'
import { func, string } from 'prop-types'

const DeleteSuccess = props => {
  const {
    closeModal,
    idRoot,
    modalHeading,
    modalMessage,
  } = props

  const timeoutRef = useRef()

  // whenever this component loads, only display it for a maximum of 3 seconds then hide it.
  useEffect(() => {
    timeoutRef.current = setTimeout(closeModal, 3000)

    return () => {
      clearTimeout(timeoutRef.current)
      closeModal()
    }
  }, [])

  return (
    <div className={'path-details-footer-modal'}>
      <h3 className={'center-text uppercase padding-half'}>
        <span
          className={'text-blue-dark'}
          id={`${idRoot}-heading`}>
          {modalHeading}
        </span>
        <span className={'confirmation-decoration'} />
      </h3>
      <p className={'padding-half center-text'}>
        <span id={`${idRoot}-message`}>{modalMessage}</span>
      </p>
    </div>
  )
}

DeleteSuccess.propTypes = {
  closeModal: func.isRequired,
  idRoot: string,
  modalHeading: string.isRequired,
  modalMessage: string.isRequired,
}

DeleteSuccess.defaultProps = {
  idRoot: 'delete-success-modal',
}

export default DeleteSuccess
